import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'

import { metaDataContent } from '../../../../../../locale/meta-data/meta-data.content.en'
import { ResourceSlug } from '../../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { BreadcrumbLink } from '../../../../../shared/interfaces/breadcrumb-link.interface'
import { Filter } from '../../../../../shared/interfaces/filter.interface'
import { Paginator } from '../../../../../shared/interfaces/paginator.interface'
import { BreadcrumbService } from '../../../../../shared/services/breadcrumb.service'
import { FlashMessageService } from '../../../../../shared/services/flash-message.service'
import { MetaService } from '../../../../../shared/services/meta.service'
import { ToolsCatalogueListComponent } from '../../../base-components/tools-catalogue-list.component'
import { MetricUseCase } from '../../../interfaces/metric-use-case.interface'
import { MetricUseCaseService } from '../../../services/metric-use-case.service'
import { FilterGroups } from './metric-use-case-filter-groups.content'

@Component({
  selector: 'app-metric-use-case-list',
  templateUrl: './metric-use-case-list.component.html',
  styleUrls: ['./metric-use-case-list.component.scss']
})
export class MetricUseCaseListComponent
  extends ToolsCatalogueListComponent
  implements OnInit
{
  @ViewChild('sortSelect', { static: false }) private sortSelect: ElementRef

  metricUseCases: Paginator<MetricUseCase>

  filterGroups: {
    name?: string
    filters: Filter[]
    isHidden?: boolean
  }[] = FilterGroups

  currentPath = '/catalogue/metric-use-cases'

  loading: boolean

  breadcrumbLinks: BreadcrumbLink[]
  resourceSlug = ResourceSlug.MetricUseCases

  constructor(
    private metricUseCaseService: MetricUseCaseService,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private flashMessageService: FlashMessageService,
    metaService: MetaService,
    router: Router
  ) {
    super(router)
    metaService.setTags(metaDataContent.toolCatalogMetricUseCaseList)
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams: Params) => {
      this.loading = true
      this.queryParams = queryParams
      this.metricUseCases = null
      ;(
        this.metricUseCaseService.list(queryParams) as Promise<
          Paginator<MetricUseCase>
        >
      )
        .then((mucRes: Paginator<MetricUseCase>) => {
          this.loading = false
          this.metricUseCases = mucRes
          if (queryParams.orderBy) {
            setTimeout(
              () => (this.sortSelect.nativeElement.value = queryParams.orderBy)
            ),
              0
          }
        })
        .catch(() => {
          this.loading = false
          this.flashMessageService.error(
            'Something went wrong. Please try again later.'
          )
        })
    })

    this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
      'toolCatalog',
      [
        {
          label: 'Metric use cases'
        }
      ]
    )
  }
}
